<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row class="mb-3">
          <v-col
            cols="12"
            md="3"
          >
            <v-select
              v-model="posMethod"
              :label="$t('posMethod')"
              :items="posMethodItems"
              height="30"
              dense
              outlined
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <autocomplete
              v-model="posBank"
              :title="$t('bank') + '/' + $t('cash')"
              type="allBankCash"
              :filter="false"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../../Mixins/general'
  import autocomplete from '../../../components/general/patial/autocomplete'
  export default {
    name: 'Zarinpal',
    components: {
      autocomplete,
    },
    mixins: [General],
    data: () => ({
      valid: true,
      apiKey: null,
      select: 'pos',
      posMethod: null,
      posMethodItems: [],
      posBank: null,
      render: false,
      isLoading: false,
    }),
    watch: {
    },
    activated () {
      this.show()
    },
    beforeMount () {
      this.posMethodItems = [
        {
          value: 'PardakhtNovin_S800_Payment',
          text: this.$t('PardakhtNovin_S800_Payment'),
        },
      ]
    },
    mounted () {
      this.show()
    },
    methods: {
      addPaymentMethod () {
        this.paymentItems.push({
          bank: null,
          value: null,
        })
      },
      remove (index) {
        this.paymentItems.splice(index, 1)
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'setting', this.$data)
          .then(res => {
            app.snakbarText = app.$t('registered')
            app.snakbarColor = 'green'
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'setting/' + 1 + '/edit', {
          params: {
            select: app.select,
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.posMethod = res.posMethod
              app.posBank = res.posBank
              app.render = true
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      copied () {
        this.snakbarText = this.$t('copied')
        this.snakbarColor = 'blue'
        this.snakbar = true
      },
    },
  }
</script>

<style scoped>
.col{
  height: 55px !important;
}
</style>
